<template>
  <div id="viewVideo" >
    <div class="close" >
      <img src="../assets/close.png" alt="" @click="$emit('click',$event.target)">
      <!-- <img src="../assets/close.png" alt="" @click="closeVideo"> -->
    </div>
    <div class="player-wrap" id="avideoPlayer"></div>
    <!-- <video controls autoplay id="avideoPlayer">
      <source :src="videoUrl" type="video/mp4">
        <source :src="videoUrl" type="video/ogg">
        <source :src="videoUrl" type="video/webm">
    </video> -->
      <img src="/static/img/xiazai.png" class="xiazai" @click.stop="toxiazai" v-show="isshowxiazai">
      <img src="/static/img/fenxiang2.png" class="fenxiang" @click.stop="tofenxiang" v-show="isshowfenxiang">
  </div>
</template>

<script>
import Player from 'xgplayer';
export default {
  props: {
    videoUrl: {
      type: String,
      required: true
    },
    videolist: {
      type: Array
    },
      videotitle: {
          type: String,
          required: true
      },
      imgurl: {
          type: String,
          required: true
      }
  },
    data(){
        return {
            isshowfenxiang:true,
            isshowxiazai:true,
            player: null
        }
    },
    mounted () {
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("android") > -1) {
            this.isshowfenxiang=true
        } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
            this.isshowfenxiang=true
        } else {
            this.isshowfenxiang=false
        }
        this.player = new Player({
          id: 'avideoPlayer',
          url: this.videoUrl,
          autoplay: true,
          definitionActive: 'click',
          rotateFullscreen: false,
          cssFullscreen: false,
        });

        this.player.emit('resourceReady', this.videolist);
        // this.isApps();
    },
    beforeDestroy () {
      this.player.destroy()
    },
    methods:{
        closeVideo()
        {
          this.player.destroy()
          this.$parent.videoFlag = false;
          // console.log("this.$parent",this.$parent,this.$parent.videoFlag)
          this.$parent.gotoHome()
        },
        tofenxiang(){
            let _this=this
            var userAgent = navigator.userAgent;
            const url = window.location.origin + '/#/videoPlayer?index=-1'
            if (userAgent.indexOf("android") > -1) {
                window.Android.shareNewsFromWebsite(_this.videotitle,url,_this.imgurl);
            } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
                let datas=JSON.stringify({fxtitle:_this.videotitle,fxurl:url,fxcoverimg:_this.imgurl})
                window.webkit.messageHandlers.shareNewsToiPhone.postMessage(datas);
            }
        },
        toxiazai(){
            // let _this=this
            // var userAgent = navigator.userAgent;
            // if (userAgent.indexOf("android") > -1) {
            //     window.Android.downloadVideo(_this.videoUrl,_this.videotitle);
            // } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
            //     // let datas=JSON.stringify({fxtitle:_this.videotitle,fxurl:_this.videoUrl,fxcoverimg:_this.imgurl})
            //     // window.webkit.messageHandlers.shareNewsToiPhone.postMessage(datas);
            // }
            // let _this=this
            // let u = navigator.userAgent;
            // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            // if (isAndroid) 
            // {
            //     try{
            //         window.Android.downloadVideo(_this.videoUrl,_this.videotitle);
            //     }
            //     catch(err)
            //     {
            //         _this.downloadVideo(_this.videoUrl)
            //     }  
            // } 
            // else
            // {
            //     _this.downloadVideo(_this.videoUrl)
            // }
            this.downloadApp(this.videoUrl)
        },
        // 下载app 打开外链 
        downloadApp(url){
          // console.log(url)
          let u = navigator.userAgent;
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isAndroid) 
          {
            // console.log("安卓安卓",isAndroid) 
            try{
              // console.log("安卓安卓") 
              window.Android.downloadSeaAtoshi(url);
            }
            catch(error){
              // console.log("安卓error",error) 
              window.location.href = url;
            }
          } 
          else if (isiOS) 
          {
            // console.log("苹果苹果",isiOS)
            try{
              // console.log("iosiosiosios")
              window.webkit.messageHandlers.downloadSeaAtoshi.postMessage(url);
            }
            catch(error){
              // console.log("苹果error",error)
              window.location.href = url;
            }
          } 
          else 
          {
            // console.log("安卓安卓else") 
            // console.log("苹果else") 
            window.location.href = url;
          }
        },
        // downloadVideo(url)
        // {
        //     window.location.href = url;
        // },
        // // 判断是否是app内
        // isApps()
        // {
        //     let u = navigator.userAgent;
        //     let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        //     if(isAndroid)
        //     {
        //     try{
        //         let isApp = window.Android.isApp();
        //         if(isApp == "android_yuanzilian")
        //         {
        //         this.isshowxiazai = false;
        //         }
        //         else
        //         {
        //         this.isshowxiazai = true;
        //         }
        //     }
        //     catch(error)
        //     {
        //         this.isshowxiazai = true;
        //     }
        //     }
        //     if(isiOS)
        //     {
        //     try{
        //         //1、通知IOS 传参数; isApp ios方法
        //         window.webkit.messageHandlers.isApp.postMessage({})
        //         window.isApp = this.isIosApp;
        //     }
        //     catch(error)
        //     {
        //         this.isshowxiazai = true;
        //     }
        //     }
        // },
        // //获取ios 
        // isIosApp:function(value){
        //     if(value == "ios_yuanzilian")
        //     {
        //         this.isshowxiazai = false;
        //     }
        //     else
        //     {
        //         this.isshowxiazai = true;
        //     }
        // },
    }
};
</script>

<style scoped>
#viewVideo {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #000;
  z-index: 1002;
}
.player-wrap {
  width: 100%!important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

/* video {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
} */
.close{
  position:absolute;
  right: 0rem;
  top: 0rem;
  width: .8rem;
  height: .8rem;
  z-index: 99999!important;
}
.close img{
  width: 100%;
}
.xiazai{
    width:0.92rem;
    height:0.92rem;
    position: fixed;
    bottom:2rem;
    right:0.19rem;
    z-index:1003;
}
.fenxiang{
    width:0.7rem;
    height:0.7rem;
    position: fixed;
    bottom:1.1rem;
    right:0.3rem;
    z-index:1003;
}
</style>
<style>
#viewVideo .xgplayer-skin-default .xgplayer-fullscreen, #viewVideo .xgplayer-skin-default .xgplayer-fullscreen-img
{
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/viewVideo.vue